export const PATHS = {
  ROOT: 'contracts',
  ME: 'contracts/me',
  getOneById: (id: number) => `${PATHS.ROOT}/${id}`,
  userId: (userId: number) => `users/${userId}/${PATHS.ROOT}`,
};
